"use client";

import { useEffect, useRef } from "react";

import { useAnalytics } from "@/lib/analytics";

import type { AnalyticsEventMap, AnalyticsEventName } from "@/lib/analytics";

interface TrackEventProps<T extends AnalyticsEventName> {
	event: T;
	properties: AnalyticsEventMap[T];
}

/**
 * Fires a single event once on mount. Lets Server Components record a view
 * without turning the whole page into a Client Component.
 */
export function TrackEvent<T extends AnalyticsEventName>({
	event,
	properties,
}: TrackEventProps<T>) {
	const { capture } = useAnalytics();
	const hasFired = useRef(false);

	useEffect(() => {
		if (hasFired.current) {
			return;
		}
		hasFired.current = true;
		capture(event, properties);
	}, [capture, event, properties]);

	return null;
}
